// Browser page translators (Google Translate in Chrome/Edge, etc.) replace
// text nodes with <font> wrappers behind React's back. On the next re-render
// React calls removeChild/insertBefore against nodes that are no longer where
// it left them and throws NotFoundError, unmounting the whole app to a white
// screen. Tolerate the mismatch instead of throwing so translated sessions
// keep working (visible symptom: a stale translated word until the next full
// section re-render, instead of a dead page).
export function installDomSafetyPatches() {
  if (typeof Node !== "function" || !Node.prototype) return;

  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function removeChild(child, ...rest) {
    if (child && child.parentNode !== this) {
      console.warn("domSafety: ignorando removeChild de un nodo movido (¿página traducida?)", child);
      return child;
    }
    return originalRemoveChild.call(this, child, ...rest);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function insertBefore(newNode, referenceNode, ...rest) {
    if (referenceNode && referenceNode.parentNode !== this) {
      console.warn("domSafety: appendChild en lugar de insertBefore ante nodo movido (¿página traducida?)", referenceNode);
      return this.appendChild(newNode);
    }
    return originalInsertBefore.call(this, newNode, referenceNode, ...rest);
  };
}
